import React, { useEffect, useState, useRef } from "react";
import {
  Modal,
  Row,
  Col,
  Form,
  Input,
  DatePicker,
  Select,
  InputNumber,
  Checkbox,
  message,
  Spin,
} from "antd";
import moment from "moment";
import { connect } from "react-redux";
import {
  getLeaveCategoryList,
  getUserInfo,
  getClientid,
  getUserRoleId,
  getRoleList,
  getAllDepartmentList,
  getUserList,
} from "redux/selectors";
import styled from "@emotion/styled";
import { NON_EMPTY_REGEX, STATUS_CODE } from "common/Constants";
import { find, result, concat, intersection, get } from "lodash";
import Button from "atoms/Button";
import {
  addDaysinDate,
  getKenyanDateTime,
  getMySqlDate,
  momentDate,
} from "utils/Date";
import { displayErrorModal } from "common/common";
import { CALL_API } from "common/API";

const StyledModal = styled(Modal)`
  .ant-modal-header {
    border-bottom: none;
    padding-top: 20px;
    padding-bottom: 30px;
  }
  .ant-modal-title {
    font-weight: bold;
    font-weight: 1.2rem;
  }
  .ant-modal-body {
    padding-top: 0px;
  }
  .ant-modal-footer {
    display: none;
  }
  .ant-form-item-label {
    font-weight: 500;
  }
  .ant-picker,
  .ant-input-number {
    width: 100%;
  }
`;

const StyledButton = styled(Button)`
  width: 120px;
  border-radius: 5px;
  width: initial;
`;

const StyledFooterDiv = styled.div`
  padding-top: 30px;
`;

function LeaveForm({
  isModalVisible,
  closeModal,
  leaveCategoryList,
  leaveDetails,
  ClientId,
  AllDepartmentList,
  userRoleId,
  roleList,
  userInfo,
  userList,
  getLeaveList,
}) {
  const [showLoader, toggleLoader] = useState(false);
  const [showLeaveValidationLoader, toggleLeaveValidationLoader] =
    useState(false);
  const [isViewOnly, setIsViewOnly] = useState(false);
  const [isCancelRequest, setCancelRequest] = useState(false);
  const [form] = Form.useForm();
  const [halfDay, setHalfDay] = useState(false);
  const [showHalfDayCheckbox, setShowHalfDayCheckbox] = useState(true);
  const [leaveBalanceCount, setLeaveBalanceCount] = useState(0);

  const { TextArea } = Input;
  const containerRef = useRef(null);

  useEffect(() => {
    if (isModalVisible) {
      form.setFieldsValue({
        leave_id: "",
        start_date: momentDate(new Date()),
        end_date: momentDate(new Date()),
        number_of_days: 1,
        // leave_type: filterbycountry[0]?.leave_category_id,
        description: "",
      });
      //onFinish({}, false);
    }
  }, [isModalVisible]);
  // const filterRoleList = roleList?.filter(
  //   (item) => item?.roleId === userRoleId
  // );
  // const filterDepartmentId = filterRoleList[0]?.department;
  // const filterDepartment = AllDepartmentList?.filter((item) =>
  //   filterDepartmentId?.includes(item?.department_id)
  // );

  const resetForm = () => {
    setShowHalfDayCheckbox(true);
    setLeaveBalanceCount(0);
    form.setFieldsValue({
      leave_id: "",
      start_date: momentDate(new Date()),
      end_date: momentDate(new Date()),
      number_of_days: 1,
      // leave_type: filterbycountry[0]?.leave_category_id,
      description: "",
    });
  };

  useEffect(() => {
    resetForm();
  }, [userRoleId, leaveCategoryList]);

  const resetHalfDay = () => {
    setHalfDay(false);
    form.setFieldsValue({ number_of_days: 1 });
  };

  const updateHalfDay = (halfday) => {
    const { number_of_days } = form.getFieldsValue();
    const roundedDays = number_of_days;
    if (halfday === true) {
      if (number_of_days >= 0.5) {
        form.setFieldsValue({
          number_of_days: roundedDays - 0.5,
        });
      }
    } else {
      if (number_of_days >= 0.5) {
        form.setFieldsValue({
          number_of_days: Math.ceil(roundedDays),
        });
      }
    }
  };

  useEffect(() => {
    if (isModalVisible) {
      if (
        moment(leaveDetails?.end_date).format("dddd") === "Saturday" &&
        moment(leaveDetails?.start_date).format("dddd") === "Saturday" &&
        moment(leaveDetails?.start_date).format("L") ===
        moment(leaveDetails?.end_date).format("L")
      ) {
        setShowHalfDayCheckbox(false);
      } else {
        setShowHalfDayCheckbox(true);
      }
    }
  }, [isModalVisible]);

  useEffect(() => {
    const {
      user_leave_id = "",
      start_date = "",
      end_date = "",
      reason = "",
      number_of_days = 0,
      leave_category_id,
      isViewOnly,
      isCancel = false,
      department_id = "",
    } = leaveDetails;

    if (user_leave_id !== "") {
      setIsViewOnly(isViewOnly);
      setCancelRequest(isCancel);

      form.setFieldsValue({
        leave_id: user_leave_id,
        start_date: momentDate(start_date),
        end_date: momentDate(end_date),
        number_of_days: number_of_days,
        // leave_type: leave_category_id,
        description: reason,
        remark: "",
        department: department_id,
      });

      // Convert to number explicitly before checking
      setHalfDay(Number(number_of_days) === 0.5);
      onFinish({}, false);
    } else if (start_date && end_date) {
      setCancelRequest(isCancel);
      form.setFieldsValue({
        start_date: momentDate(start_date),
        end_date: momentDate(end_date),
        leave_id: "",
        number_of_days: 1, // Default full-day leave
        // leave_type: filterbycountry[0]?.leave_category_id,
        description: "",
        remark: "",
        department: "",
      });

      // Reset halfDay for new leave requests
      setHalfDay(false);
      onFinish({}, false);
    }
  }, [leaveDetails, isModalVisible]);


  // Note: First params is needed
  const onFinish = async (values, saveLeave = true) => {
    if (saveLeave) toggleLoader(true);
    else toggleLeaveValidationLoader(true);
    const {
      start_date,
      end_date,
      number_of_days,
      leave_type,
      department,
      description,
      remark,
    } = form.getFieldsValue();

    const selectedLeaveType = leaveCategoryList.find(
      (item) => item.leave_category_id?.toString() === leave_type?.toString()
    );

    if (
      selectedLeaveType &&
      selectedLeaveType.leave_category_name === "Compassionate Leave" &&
      leaveBalanceCount > 0
    ) {
      message.error(
        "You cannot apply for compassionate leave as you still have available annual leaves."
      );

      if (saveLeave) toggleLoader(false);
      else toggleLeaveValidationLoader(false);
      return;
    }
    const filterleavetype = leaveCategoryList?.filter(
      (item) => item.leave_category_id === leave_type?.toString()
    );
    const selectedLeave = finalFilteredLeaves.find(
      item => String(item.leave_category_id) === String(leave_type)
    );
    const departmentId = result(
      find(AllDepartmentList, (e) => {
        return filteruser[0]?.leveldepartmentname[0]?.includes(
          e.department_name
        );
      }),
      "department_id"
    );
    const { user_leave_id = "" } = leaveDetails;
    const { code, leaveBalance, totalNumberOfDaysInLeave, reason } =
      await CALL_API(`save-leave/${ClientId}`, "post", {
        leave_id: user_leave_id,
        start_date: getMySqlDate(start_date),
        end_date: getMySqlDate(end_date),
        number_of_days,
        leave_category_id: leave_type?.toString(),
        reason: description,
        decline_reason: isCancelRequest ? remark : "",
        is_cancel_request: isCancelRequest,
        department_name: filteruser[0]?.leveldepartmentname[0],
        isSaving: saveLeave,
        department_id: departmentId,
        old_number_of_day: leaveDetails?.number_of_days
          ? leaveDetails?.number_of_days
          : "",
        holiday: filterleavetype[0]?.holiday?.length
          ? filterleavetype[0]?.holiday
          : "No",
        weekend: filterleavetype[0]?.weekend?.length
          ? filterleavetype[0]?.weekend
          : "No",
        isSaturday: filterleavetype[0]?.isSaturday?.length
          ? filterleavetype[0]?.isSaturday
          : "No",
        employeeid: filteruser[0]?.employeeid,
        leave_category_name: selectedLeave?.leave_category_name || "",
        fullname: filteruser[0]?.fullname,
        officesupervisorid: filteruser[0]?.OfficeSupervisorId == "none" ? filteruser[0]?.employeeid : filteruser[0]?.OfficeSupervisorId,
        officesupervisorname: filteruser[0]?.officesupervisor == "none" ? filteruser[0]?.fullname : filteruser[0]?.officesupervisor,
        country: filteruser[0]?.managingoffice,
      });
    setLeaveBalanceCount(leaveBalance);

    const payloadVariable = {
      leave_id: user_leave_id,
      start_date: getMySqlDate(start_date),
      end_date: getMySqlDate(end_date),
      number_of_days,
      leave_category_id: leave_type,
      reason: description,
      decline_reason: isCancelRequest ? remark : "",
      is_cancel_request: isCancelRequest,
      isSaving: saveLeave,
    };
    if (saveLeave) toggleLoader(false);
    else toggleLeaveValidationLoader(false);
    if (code === STATUS_CODE.SOMETHING_WENT_WRONG) {
      message.error(`Oops!! something went wrong`);
    } else if (code === STATUS_CODE.INVALID_PAYLOAD) {
      if (
        filterleavetype[0]?.holiday === "No" &&
        filterleavetype[0]?.weekend === "No"
      ) {
        message.error(`You cannot apply for leave on Holidays and Sundays`);
      } else if (filterleavetype[0]?.holiday === "No") {
        message.error(`You cannot apply for leave on Holidays`);
      } else if (filterleavetype[0]?.isSaturday === "No") {
        message.error(`You cannot apply for leave on Saturdays`);
      } else if (filterleavetype[0]?.weekend === "No") {
        message.error(`You cannot apply for leave on Sundays`);
      } else {
        message.error(`Invalid payload. Please enter correct data`);
      }
    } else if (code === STATUS_CODE.RECORD_EXIST) {
      message.error(`Leave already exists`);
    } else if (code === STATUS_CODE.ANNUAL_LEAVE_AVAILABLE) {
      message.error(
        `You can not apply compassionate leave. You still have annual leaves.`
      );
    } else if (code === STATUS_CODE.SICK_LEAVE_AVAILABLE) {
      message.error(
        `You can not apply sick leave(half-pay). You still have sick leaves.`
      );
    } else if (code === STATUS_CODE.LEAVE_EXCEED) {
      form.setFieldsValue({
        number_of_days: totalNumberOfDaysInLeave,
      });
      displayErrorModal(
        `You are exceeding your leave quota. your current leave balance is ${leaveBalance}`
      );
    } else if (code === STATUS_CODE.SUCCESS) {
      if (saveLeave) {
        message.success(
          isCancelRequest
            ? "Leave application request has been submitted"
            : `Leave has been ${user_leave_id ? "updated" : "applied"}`
        );
        form.resetFields();
        closeModal(true);
        setShowHalfDayCheckbox(true);
        getLeaveList();
      } else {
        form.setFieldsValue({
          number_of_days: totalNumberOfDaysInLeave,
        });
      }
    }
  };

  const restrictPastDate = (current, element) => {
    let customDate = moment("2022-08-01").format("YYYY-MM-DD");
    if (element === "end_date") {
      return current < moment(form.getFieldValue("start_date"));
    }
    return current && current < moment(customDate, "YYYY-MM-DD");
  };

  const validateDateRange = () => {
    const endDate = moment(form.getFieldValue("end_date"));
    const startDate = moment(form.getFieldValue("start_date"));
    if (endDate < startDate) {
      form.setFieldsValue({ end_date: startDate });
      onFinish({}, false);
    } else {
      onFinish({}, false);
    }
  };

  const dateChange = () => {
    onFinish({}, false);
    updateHalfDay();
  };

  const hideHalfDay = () => {
    const { start_date, end_date } = form.getFieldsValue();
    if (
      moment(end_date).format("dddd") == "Saturday" &&
      moment(start_date).format("dddd") == "Saturday" &&
      moment(start_date).format("L") == moment(end_date).format("L")
    ) {
      setShowHalfDayCheckbox(false);
    } else {
      setShowHalfDayCheckbox(true);
    }
  };

  const updateEndDate = () => {
    const { start_date, number_of_days } = form.getFieldsValue();
    if (number_of_days >= 1) {
      const roundedDays = Math.ceil(number_of_days);
      form.setFieldsValue({
        number_of_days: roundedDays,
        end_date: momentDate(addDaysinDate(start_date, roundedDays - 1)),
      });
    }
  };

  const checkBoxStyle = {
    marginTop: "55px",
    position: "relative",
    bottom: "15px",
  };

  const filterrolelist = roleList?.filter((val) => val?.roleId === userRoleId);
  const filterdepartmentid = filterrolelist[0]?.department;
  const filterlocationid = filterrolelist[0]?.locationId;

  const filterleaves = [];
  leaveCategoryList?.forEach((item) => {
    if (item?.departmentId?.length > 0 && item?.locationId?.length > 0) {

      if (intersection(item?.locationId, filterlocationid).length > 0) {
        filterleaves.push(item);
      }
    }
  });

  const filteruser = userList?.filter(
    (item) => item.userid === userInfo?.userid
  );
  const filtergender = filteruser[0]?.gender;
  const filteredCategoriesbygender =
    filtergender?.toLowerCase() === "male"
      ? filterleaves?.filter(
        (item) => item.eligible?.toLowerCase() !== "female"
      )
      : filterleaves?.filter((item) => item.eligible?.toLowerCase() !== "male");
  const filterbycountry = filteredCategoriesbygender?.filter((item) =>
    item?.locationId?.includes(filteruser[0]?.baselocationid)
  );



  const userLocationId = String(filteruser[0]?.baselocationid || "");

  const filterByLocation = leaveCategoryList.filter(item =>
    (item.locationId || [])
      .map(id => String(id))
      .includes(userLocationId)
  );

  const finalFilteredLeaves = filterByLocation.filter(item => {
    const eligible = item.eligible?.toLowerCase();

    if (filtergender === "male") {
      return eligible === "both" || eligible === "male";
    }

    if (filtergender === "female") {
      return eligible === "both" || eligible === "female";
    }

    // in case gender is missing or other
    return eligible === "both";
  });

  const actionOptions = finalFilteredLeaves.map(item => ({
    ...item,
    label: `${item.leave_category_name}`,
    value: item.leave_category_id
  }));


  useEffect(() => {
    if (!isModalVisible) return;
    if (!actionOptions.length) return;

    if (leaveDetails?.leave_category_id) return;

    const currentLeaveType = form.getFieldValue("leave_type");
    if (currentLeaveType) return;

    const annualLeave = actionOptions.find(
      (opt) => opt.label === "Annual Leave"
    );

    form.setFieldsValue({
      leave_type: annualLeave
        ? annualLeave.value
        : actionOptions[0].value,
    });

  }, [isModalVisible, actionOptions, leaveDetails]);




  if (filterbycountry?.length > 0) {
    filterbycountry.sort((a, b) => {
      if (a.leave_category_name === "Annual Leave") return -1;
      if (b.leave_category_name === "Annual Leave") return 1;
      return 0;
    });
  }
  return (
    <StyledModal
      title="Leave Details"
      visible={isModalVisible}
      onCancel={() => {
        closeModal(false);
        resetHalfDay();
        resetForm();
      }}
      width={600}
      footer={[]}
    >
      <Form
        form={form}
        name="leaveform"
        layout="vertical"
        initialValues={{
          leave_id: "",
          start_date: momentDate(getKenyanDateTime()),
          end_date: momentDate(getKenyanDateTime()),
          number_of_days: 1,
          // leave_type: "Annual Leave",
          description: "",
          remark: "",
          department: "",
        }}
        onFinish={onFinish}
      >
        <Row gutter={20}>
          <Col xs={24} sm={24} md={24} ref={containerRef}>
            <Form.Item
              label="Leave Type"
              name="leave_type"
              rules={[
                {
                  required: true,
                  pattern: NON_EMPTY_REGEX,
                  message: "Leave type is required",
                },
              ]}
            >


              <Select
                showSearch
                placeholder="Search leave type"
                name="leave_type"
                options={actionOptions}
                optionFilterProp="label"
                filterOption={(input, option) =>
                  option.label.toLowerCase().includes(input.toLowerCase())
                }
              />



            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={12} ref={containerRef}>
            <Form.Item
              label="Start Date"
              name="start_date"
              rules={[
                {
                  required: true,
                  pattern: NON_EMPTY_REGEX,
                  message: "Start date is required",
                },
                () => ({
                  // Note: First param is needed
                  validator(rule, value) {
                    const date = moment(value);
                    return date.isValid()
                      ? Promise.resolve()
                      : Promise.reject();
                  },
                }),
              ]}
            >
              <DatePicker
                format="DD-MM-YYYY"
                onChange={() => {
                  validateDateRange();
                  hideHalfDay();
                }}
                disabled={isViewOnly || halfDay}
                getPopupContainer={() => containerRef.current}
              />
            </Form.Item>
          </Col>

          <Col xs={24} sm={24} md={12} ref={containerRef}>
            <Form.Item
              noStyle
              shouldUpdate={(prevValues, currentValues) =>
                prevValues.start_date !== currentValues.start_date
              }
            >
              {() => (
                <Form.Item
                  label="End Date"
                  name="end_date"
                  rules={[
                    {
                      required: true,
                      pattern: NON_EMPTY_REGEX,
                      message: "End date is required",
                    },
                    () => ({
                      // first parameter is needed
                      validator(rule, value) {
                        const date = moment(value);
                        return date.isValid()
                          ? Promise.resolve()
                          : Promise.reject();
                      },
                    }),
                  ]}
                >
                  <DatePicker
                    disabledDate={(current) =>
                      restrictPastDate(current, "end_date")
                    }
                    format="DD-MM-YYYY"
                    onChange={() => {
                      dateChange();
                      setHalfDay(false);
                      hideHalfDay();
                    }}
                    disabled={isViewOnly || halfDay}
                    getPopupContainer={() => containerRef.current}
                  />
                </Form.Item>
              )}
            </Form.Item>
          </Col>

          <Col xs={24} sm={24} md={12}>
            <Spin spinning={showLeaveValidationLoader}>
              <Form.Item label="No. of Days" name="number_of_days">
                <InputNumber min={0.5} onChange={updateEndDate} disabled />
              </Form.Item>
            </Spin>
          </Col>
          <Col
            xs={24}
            sm={24}
            md={12}
            className="d-flex justify-content-between align-items-center"
          >
            {showHalfDayCheckbox && (
              <Checkbox
                style={checkBoxStyle}
                checked={halfDay}
                // onChange={() => {
                //   setHalfDay((prevCheck) => {
                //     const newCheck = !prevCheck;
                //     const updatedDays = newCheck ? 0.5 : 1; // Toggle between 0.5 and 1
                //     form.setFieldsValue({ number_of_days: updatedDays });
                //     return newCheck;
                //   });
                // }}
                onChange={(e) => {
                  updateHalfDay(!halfDay);
                  setHalfDay((prevCheck) => !prevCheck);
                }}
              >
                Half day
              </Checkbox>
            )}
            {leaveBalanceCount > 0 && (
              <div
                style={{
                  fontSize: "14px",
                  marginTop: 40,
                  color: " #5d5f68",
                  fontWeight: 500,
                }}
              >
                <p>
                  Leave Balance :{" "}
                  <span style={{ fontSize: "14px", color: "#1890ff" }}>
                    {leaveBalanceCount}{" "}
                    {leaveBalanceCount === 1 ? "day" : "days"}
                  </span>
                </p>
              </div>
            )}
          </Col>
        </Row>

        {!isViewOnly && (
          <div>
            {isCancelRequest && (
              <Form.Item shouldUpdate>
                {({ getFieldValue }) => {
                  const leave_type = getFieldValue("leave_type");
                  return (
                    leave_type !== true && (
                      <Form.Item
                        label="Detailed Reason"
                        name="description"
                        rules={[
                          {
                            required: true,
                            pattern: NON_EMPTY_REGEX,
                            message: "Leave reason is required",
                          },
                        ]}
                      >
                        <TextArea
                          placeholder="Type something.."
                          maxLength={500}
                          disabled={isViewOnly}
                          autoSize={{ minRows: 2, maxRows: 6 }}
                        />
                      </Form.Item>
                    )
                  );
                }}
              </Form.Item>
            )}
            {!isCancelRequest && (
              <Form.Item shouldUpdate>
                {({ getFieldValue }) => {
                  const leave_type = getFieldValue("leave_type");
                  return (
                    leave_type !== true && (
                      <Form.Item
                        label="Detailed Reason"
                        name="description"
                        rules={[
                          {
                            required: form.getFieldValue("leave_type"),
                            pattern: NON_EMPTY_REGEX,
                            message: "Reason is required",
                          },
                        ]}
                      >
                        <TextArea
                          laceholder="Type something.."
                          maxLength={500}
                          disabled={isViewOnly}
                          autoSize={{ minRows: 2, maxRows: 6 }}
                        />
                      </Form.Item>
                    )
                  );
                }}
              </Form.Item>
            )}
          </div>
        )}
        {!isViewOnly && (
          <StyledFooterDiv className="align-right">
            {!isCancelRequest && (
              <StyledButton
                type="primary"
                onClick={() => {
                  resetForm();
                  resetHalfDay();
                }}
                disabled={showLeaveValidationLoader}
              >
                Reset All
              </StyledButton>
            )}
            <StyledButton
              loading={showLoader}
              type="primary"
              htmlType="submit"
              disabled={showLeaveValidationLoader}
            >
              {showLoader ? "Submitting" : "Submit"}
            </StyledButton>
          </StyledFooterDiv>
        )}
      </Form>
    </StyledModal>
  );
}

const mapStateToProps = (state) => ({
  leaveCategoryList: getLeaveCategoryList(state),
  userInfo: getUserInfo(state),
  ClientId: getClientid(state),
  AllDepartmentList: getAllDepartmentList(state),
  userRoleId: getUserRoleId(state),
  roleList: getRoleList(state),
  userList: getUserList(state),
});

export default connect(mapStateToProps, null)(LeaveForm);
